import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }

import { useForm } from '@inertiajs/vue3';
    import { Button } from '@/components/ui/button';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import { InputRow } from '@/components/ui/form';
    import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
    import { ref } from 'vue';
    import { toast } from 'vue-sonner';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePasswordForm',
  setup(__props) {

    const form = useForm({
        current_password: '',
        password: '',
        password_confirmation: '',
    });

    const passwordInput = ref<HTMLInputElement | null>(null);
    const currentPasswordInput = ref<HTMLInputElement | null>(null);

    const submit = () => {
        form.put(route('v2.profile.password.update'), {
            preserveScroll: true,
            onSuccess: () => {
                toast.success('Adgangskode opdateret');
                form.reset();
            },
            onError: (errors: any) => {
                if (errors.password) {
                    form.reset('password', 'password_confirmation');
                    if (passwordInput.value instanceof HTMLInputElement) {
                        passwordInput.value.focus();
                    }
                }

                if (errors.current_password) {
                    form.reset('current_password');
                    if (currentPasswordInput.value instanceof HTMLInputElement) {
                        currentPasswordInput.value.focus();
                    }
                }
            },
        });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "w-full max-w-lg self-center" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(CardTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.update_password')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createVNode(_unref(CardContent), { class: "space-y-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "current_password",
              label: "forms.password_current"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "current_password",
                  ref_key: "currentPasswordInput",
                  ref: currentPasswordInput,
                  modelValue: _unref(form).current_password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).current_password) = $event)),
                  type: "password",
                  autocomplete: "current-password",
                  placeholder: _ctx.$t('forms.password_current')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "password",
              label: "forms.password_new"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "password",
                  ref_key: "passwordInput",
                  ref: passwordInput,
                  modelValue: _unref(form).password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
                  type: "password",
                  autocomplete: "new-password",
                  placeholder: _ctx.$t('forms.password_new')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _unref(form),
              name: "password_confirmation",
              label: "forms.password_new_confirm"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "password_confirmation",
                  modelValue: _unref(form).password_confirmation,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).password_confirmation) = $event)),
                  type: "password",
                  autocomplete: "new-password",
                  placeholder: _ctx.$t('forms.password_new_confirm')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"])
          ]),
          _: 1
        }),
        _createVNode(_unref(CardFooter), { class: "border-t" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              disabled: _unref(form).processing || !_unref(form).isDirty,
              loading: _unref(form).processing
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.update_password')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}
}

})